import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/request-types'

export default {
  list(client_id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}`, { params: { client_id } })
  },
  create(data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, data)
  },
  update(id, data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, data)
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
}